export default "__VITE_ASSET__DdDJ$j5Y__"